module.exports = __webpack_public_path__ + "img/postgres.21eea274.png";